import React, { Component } from 'react'
import { connect } from 'react-redux'

import { setDay } from 'cogsworth/utils/store'
import './DayItem.css'

class DayItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectOnLoad: false
    }

    this.handleClick = this.handleClick.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.loading && !nextProps.loading && this.state.selectOnLoad) {
      if (nextProps.availableTimes.length > 0) {
        this.props.dispatch(setDay(this.props.date)) // TOOD: This feels like a race condition workaround
      } else {
        this.setState({ selectOnLoad: false })
      }
    }
  }

  handleClick() {
    if (this.props.loading) {
      this.setState({ selectOnLoad: true })
    } else {
      this.props.dispatch(setDay(this.props.date))
    }
  }

  render() {
    const { date, loading, availableTimes } = this.props
    const { selectOnLoad } = this.state

    if (!loading && availableTimes.length === 0) {
      return <div className="day-item disabled">&nbsp;<br/>&nbsp;</div>
    }

    return (
      <div className="day-item" onClick={this.handleClick} style={ { backgroundColor: selectOnLoad ? '#f1f1f1' : 'transparent' } }>
        <strong>{ date.format('ddd') } { date.date() }</strong><br/>
        <span className="month">{ date.format('MMM') }</span><span className="year">&nbsp;{ date.year() }</span>
      </div>
    )
  }
}

export default connect()(DayItem)
